<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content content-type" v-loading.fullscreen.lock="loading">
        <!-- <div class="go-back" @click="goBack">返回</div> -->
        <div class="main-title pd">自定义邀请函</div>
        <div  v-if="detail.deadline" class="main-sub pd">提交截止日期：{{ detail.deadline }}</div>
        <!-- <div class="main-sub pd">
          1、自定义邀请函可选择公司名或品牌名展示在邀请函上；2、上传图片需注意空出文字和二维码位置，且上传的图片需符合法律法规要求；3、自定义的邀请函图片请自行下载保存。
        </div> -->
        <div class="poster-wrap pd">
          <div class="left down-img">
            <el-image class="img-icon" v-if="imgUrl" :src="imgUrl"></el-image>
            <el-image class="img-bottom" :src="imgbUrl"></el-image>

            <div class="brand">
                {{userdata.name_cn}}
            </div>
            <!-- <div class="booth">
              {{ userdata.datainfo.hallNo }} {{ userdata.datainfo.boothNo }}
            </div>
            <div class="brand">
              {{ value == 1 ? userdata.datainfo.companyName :  userdata.datainfo.brandName == '' ? userdata.datainfo.companyName : userdata.datainfo.brandName}}
            </div> -->
            <!--<canvas  ref="qrcodeCanvas"></canvas>-->
            <qr-code text="First QR Code Content"  class="code-icon"></qr-code>

            <!--<el-image-->
              <!--v-if="codeUrl"-->
              <!--class="code-icon"-->
              <!--:src="codeUrl"-->
            <!--&gt;</el-image>-->
          </div>
          <div class="right">
            <!-- <p class="title">选择文字</p> -->
            <!-- <el-select v-model="value" placeholder="请选择" @change="changeValue">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select> -->
            <p class="title">选择背景</p>
            <div class="upload-list">
              <div
                class="upload-image"
                :class="{ active: currentIndex == index }"
                v-for="(item, index) in imgs"
                :key="index"
                @click="changeBg(index)"
              >
                <el-image
                  class="image"
                  :src="$imgUrl + item.image"
                ></el-image>
                <img

                  class="close-icon"
                  src="../assets/close_icon.png"
                  alt=""
                  @click.stop="deleteImg(index, item.id)"
                />
              </div>
              <el-upload
                v-if="imgs.length < 5"
                class="upload-add"
                :action="$Url"
                :headers="headers"
                name="file"
                :on-success="handlePosterSuccess"
                :on-error="handlePosterError"
              >
                <i class="el-icon-plus"></i>
                <div class="el-upload__text">
                  <p style="color: #666; font-size: 16px">上传图片</p>
                  <p>建议尺寸800*1420</p>
                </div>
              </el-upload>
            </div>
            <div class="create-btn" @click="createPoster">生成邀请函</div>
          </div>
        </div>
        <!-- 已制作的邀请函 -->
        <div class="diy-list pd">
          <h3>已制作的邀请函</h3>
          <div class="diy-item">
            <div
              class="down-img item"
              :id="'posterHtml_' + index"
              v-for="(item, index) in makeImgs"
              :key="index"
            >
              <el-image
                class="img-icon"
                v-if="item.image"
                :src="item.image"
              ></el-image>
              <el-image class="img-bottom" :src="imgbUrl"></el-image>
              <div class="brand">
                {{userdata.name_cn}}
              </div>

              <!--<div class="booth">{{ item.hallNo }} {{ item.boothNo }}</div>-->
              <!--<div class="brand">-->
                <!--{{ item.characters }}-->
              <!--</div>-->
              <qr-code text="Second QR Code Content" class="code-icon"></qr-code>

              <!--<el-image-->
                <!--v-if="codeUrl"-->
                <!--class="code-icon"-->
                <!--:src="codeUrl"-->
              <!--&gt;</el-image>-->
              <div class="item-mask">
                <div class="item-btn" @click="downPoster(index)">下载</div>
                <div class="item-btn del-btn" @click="delMakeImg(index, item.id)">删除</div>
              </div>
            </div>
          </div>
        </div>
        <div class="conf-btn flex">
          <!-- 可跳过需要验证 -->
          <template  v-if="detail.is_skip==1&&detail.is_verify==1">
             <div class="btn" @click="next('skip')">跳过</div>
             <div class="btn next_btn" @click="next('next')">下一步</div>
          </template>
           <!-- 可跳过无需验证 -->
          <template  v-if="detail.is_skip==1&&detail.is_verify==0">
            <div class="btn next_btn" @click="next('known')">已知悉</div>
          </template>
          <!-- 不可跳过需要验证 -->
          <template  v-if="detail.is_skip==0&&detail.is_verify==1">
              <div class="btn next_btn" @click="next('next')">下一步</div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { backgroundList,addbackground,delbackground,invitationList,addinvitation,delinvitation,getCode, setBackground, makeBackground,skipOrReadStep} from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
import html2canvas from "html2canvas";

import QrCode from '../components/qrcode.vue'

export default {
  components: { top, navMenu, QrCode },
  name: "diyPoster",
  data() {
    return {
      loading: false,
      active: 4,
      headers: {},
      imgUrl: "",
      imgbUrl:'',
      userdata: {},
      options: [
        {
          value: 1,
          label: "公司名",
        },
        {
          value: 2,
          label: "品牌名",
        },
      ],
      value: 1,
      imgs: [], // 背景图片
      currentIndex: 0,
      codeUrl: "",
      makeImgs: [], //已制作的邀请函列表
      detail:{},
      text:'https://www.baidu.com'
    
    };
  },
  mounted() {
    let token = localStorage.getItem("token");this.userdata = JSON.parse(localStorage.getItem("userdata"));
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "/diyPoster";
    });
    this.detail=stepMenuList[index]
    this.active = index;
    this.headers = {
          token:token,
    };

    //获取背景图
    this.getBackgroundList();
    //获取已制作的邀请函
    this.getMakeBackground();
    //获取列表
    // this.getXcxCode();
      this.generateQRCode()
  },
  methods: {
      generateQRCode() {
          new QRCode(this.$refs.qrCodeDiv, {
              text: "https://www.baidu.com",
              width: 46,
              height: 46,
              colorDark: "#333333", //二维码颜色
              colorLight: "#ffffff", //二维码背景色
              correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
          });
          new QRCode(this.$refs.qrCodeDiv1, {
              text: "https://www.baidu.com",
              width: 46,
              height: 46,
              colorDark: "#333333", //二维码颜色
              colorLight: "#ffffff", //二维码背景色
              correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
          });
          // const canvas = this.$refs.qrcodeCanvas
          // QRCode.toCanvas(canvas, this.text, res => {
          //     if (res){
          //         console.error(res)
          //     }
          // })
      },
                   // 跳转下一步
   next(type) {
      if(type=='next'){//下一步
        if(this.detail.action==1||this.detail.action==4){
          this.toPath();
        }else{
          this.$message.warning("请完善信息!")
        }

      }else if(type=='skip'){//跳过
        this.skipOrReadStep(1)
      }else if(type=='known'){//已知悉
        this.skipOrReadStep(2)
      }
    },
    // 跳过或者已知悉
    skipOrReadStep(action){
      let data={
        type:JSON.parse(localStorage.getItem("userdata")).type,
        action,
        mark:this.detail.mark
      }
      skipOrReadStep(data).then(res=>{
        if(res.code==1){
          this.$message.success("操作成功")
          this.toPath()
        }else{
          this.$message.error(res.msg)
        }

      }).catch(err=>{
        console.log(err)
      })

    },
    toPath() {
        this.active = this.active + 1;
        console.log(this.active,"this.active")
        let { link_url, menu_title, id } = this.stepMenuList[this.active];
        if (link_url == "/exhibitorManual" || link_url == "/standPrepare") {
          this.$router.push({
            path: link_url
          });
        } else {
          this.$router.push({
            path: link_url
          });
        }
      },
    // 返回
    goBack() {
      this.$router.back();
    },

    //获取背景图
    getBackgroundList() {
      backgroundList({}).then((res) => {
          console.log(res, '======res')
          if (res.code == 1) {
            let data = res.data.lists;
            if (data.length > 0) {
              this.imgs = data;
              //背景默认第一个
              this.imgUrl = this.$imgUrl + this.imgs[0].image;
            }
          }
        })
        .catch((err) => {});
    },
    //获取已制作的邀请函列表
    getMakeBackground() {
        invitationList({}).then((res) => {
          //console.log(res, "======获取已制作的邀请函列表");
          if (res.code == 1) {
            let data = res.data.lists;
            if (data.length > 0) {
              data.forEach(item => {
                item.image = this.$imgUrl + item.image
              });
              this.makeImgs = data;
            }
          }
        })
        .catch((err) => {});
    },
    //获取动态小程序码
    // getXcxCode() {
    //
    //   this.codeUrl =''
    //   // let data = this.$qs.stringify({
    //   //   scene: "&mid=" + "E" + "&sid=" + userdata.datainfo.id + "&e=C",
    //   //   page: "pages/preCheck/preCheck",
    //   // });
    //   // getCode(data).then((res) => {
    //   //     //console.log(res, "======获取动态小程序码");
    //   //     if (res.status == 200) {
    //   //       // this.codeUrl = `data:image/png;base64,${res.data}`;
    //
    //   //     }
    //   //   })
    //   //   .catch((err) => {
    //   //     console.log(err);
    //   //   });
    // },
    // 海报上传成功
    handlePosterSuccess(resData, file, fileList) {
      if (resData.code === 1) {
       
        let data = this.$qs.stringify({
           image: resData.data.url,
        });
        addbackground(data).then((res) => {
            console.log(res, "======res");
            if (res.code == 1) {
                this.getBackgroundList()
              // let data = res.data;
              // if (data.length > 0) {
              //   this.imgs = data;
              // }
            }
          })
          .catch((err) => {});
      }
    },
    //删除背景图
    deleteImg(index, id) {
      this.$confirm("确定要删除当前背景图吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            id,
          };
            delbackground(data).then((res) => {
              console.log(res, "======res");
              if (res.code == 1) {
                this.imgs.splice(index, 1);
              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch((err) => {});
        })
        .catch(() => {});
    },
    // 海报上传失败
    handlePosterError(err, file, fileList) {
      this.$message.error(err.message);
    },
    //切换选中海报
    changeBg(index) {
      //当前选中海报背景
      this.currentIndex = index;
      //左侧展示海报背景
      this.imgUrl = this.$imgUrl + this.imgs[index].image;
    },
    //生成邀请函
    createPoster() {
      let { currentIndex, imgs } = this;
      let data = this.$qs.stringify({
        // company_id: imgs[currentIndex].company_id,
        // characters_type: value,
        // characters:
        //   value == 1
        //     ? userdata.datainfo.companyName
        //     : userdata.datainfo.brandName == ""
        //     ? userdata.datainfo.companyName
        //     : userdata.datainfo.brandName,
        // hallNo: userdata.datainfo.hallNo,
        // boothNo: userdata.datainfo.boothNo,
        image: imgs[currentIndex].image,

      });
        addinvitation(data).then((res) => {
          if (res.code == 1) {
             this.getMakeBackground()

          }
        })
        .catch((err) => {});
    },
    //删除已制作的邀请函
    delMakeImg(index, id){
      this.$confirm("确定要删除邀请函吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
          let data = {
            id,
          };
            delinvitation(data).then((res) => {
              if (res.code == 1) {
                this.makeImgs.splice(index, 1);
              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch((err) => {});
        })
        .catch(() => {});
    },
    // 下载海报
    downPoster(index) {
      let that = this;
      that.loading = true;
      //图片转成base64
      let image = that.makeImgs[index].image;
      that.convertImageToBase64(image, that.base64CallBack, index);
      let id = 'posterHtml_' + index;
      let posterDOM = document.getElementById(id);
      html2canvas(posterDOM, {
        width: posterDOM.offsetWidth,
        height: posterDOM.offsetHeight,
        //按比例增加分辨率
        scale: window.devicePixelRatio * 2.5, // 设备像素比
        useCORS: true, //（图片跨域相关）
        allowTaint: true, //允许跨域（图片跨域相关）
        logging: false,
        letterRendering: true,
      }).then(function (canvas) {
        let posterImgURL = canvas.toDataURL("image/png");
        let a = document.createElement("a");
        a.download = "邀请函";
        a.href = posterImgURL;
        a.dispatchEvent(new MouseEvent("click"));
        that.loading = false;
      });
    },
    //下载邀请函时，图片转base64
    convertImageToBase64(imgUrl, callback, index) {
      const image = new Image();
      image.setAttribute('crossOrigin', 'anonymous');
      image.src = imgUrl;
      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataUrl = canvas.toDataURL();
        callback && callback(dataUrl, index);
      };
    },
    base64CallBack(base64, index) {
      this.makeImgs[index].image = base64;
    },
  },
};
</script>

<style lang="scss" scoped>
   .conf-btn {
        position: absolute;
        bottom: 30px;
        left: 50%;
        transform: translateX(-50%);
        .btn {
          min-width: 128px;
          height: 36px;
          cursor: pointer;
          margin: 0 10px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          line-height: 36px;
          text-align: center;
          background: #ffffff;
          border: 1px solid #CAD2DD;
          border-radius: 9px;
          &:hover {
            text-decoration: underline;
          }
        }
  .next_btn {
    color: #fff;
    background: linear-gradient( 90deg, #F27FC0 0%, #E40080 100%);
    border: none;
  }
}
.content-type {
  .go-back {
    margin-left: 30px;
  }
  .main-title {
    margin-top: 20px;
  }
  .main-sub {
    font-size: 22px;
    color: #646889;
    line-height: 30px;
    margin-top: 8px;
    margin-bottom: 50px;
  }
  .poster-wrap {
    margin-top: 20px;
    display: flex;
    padding-bottom: 30px;
    border-bottom: 11px solid #f5f5fa;
    .left {
      width: 220px;
      height: 393px;
      margin-right: 50px;
      .img {
        width: 100%;
      }
    }
    .right {
      width: 600px;
      .title {
        color: #000;
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 3px;
      }
      .el-select {
        width: 100%;
        margin-bottom: 20px;
      }
      .upload-list {
        display: flex;
        margin-top: 10px;
        .active {
          border: 2px solid #1677ff;
        }
        .upload-image {
          width: 88px;
          height: 137px;
          cursor: pointer;
          margin-right: 18px;
          position: relative;
          .close-icon {
            position: absolute;
            top: 3px;
            right: 3px;
            width: 20px;
            height: 20px;
          }
          .image {
            width: 100%;
            height: 100%;
          }
        }
      }
      .upload-add {
        width: 137px;
        height: 137px;
        line-height: 20px;
        border-radius: 2px;
        overflow: hidden;
        background: #f9f9f9;
        border: 1px dashed #bfbfbf;
        .el-icon-plus {
          color: #999 !important;
          font-size: 40px;
          margin: 15px 0 0;
          line-height: 45px;
        }
        .el-upload__text {
          height: auto;
          color: #999;
          font-size: 14px;
          line-height: 18px;
          p {
            margin: 5px 10px 0;
          }
        }
      }
      .create-btn {
        width: 218px;
        height: 50px;
        color: #fff;
        font-size: 14px;
        line-height: 50px;
        text-align: center;
        // margin-top: 30px;
        margin-top: 75px;
        cursor: pointer;
        border-radius: 8px;
        background: #1677ff;
        border: 1px solid #1677ff;
        transition: all 0.2s;
        &:hover {
          opacity: 0.9;
        }
      }
    }
  }
  .diy-list {
    padding-top: 30px;
    h3 {
      font-size: 26px;
      font-weight: 500;
      color: #2c2c2e;
      line-height: 37px;
      margin-bottom: 20px;
    }
  }
  .down-img {
    width: 350px;
    height: auto;
    cursor: pointer;
    position: relative;
    margin-right: 60px;
    margin-bottom: 20px;
    .img-icon {
      width: 100%;
      height: 100%;
    }
    .img-bottom {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
    }
    .booth {
      position: absolute;
      top: 220px;
      left: 0;
      width: auto;
      color: #fff;
      font-weight: 500;
      font-size: 20px;
      padding: 3px 8px 3px 13px;
      max-width: 100%;
      background: rgba($color: #E9BA77, $alpha: 0.88);
    }
    .brand {
      position: absolute;
      top: 255px;
      left: 0;
      color: #fff;
      font-size: 15px;
      max-width: 100%;
      min-width: 125px;
      font-weight: 500;
      padding: 3px 7px 3px 13px;
      background: rgba($color: #0160D2, $alpha: 0.88);
    }
    .code-icon {

      position: absolute;
      z-index: 9;
      bottom: 28px;
      right: 15px;

    }
  }
  .diy-item {
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 220px;
      height: 392px;
      margin-right: 33px;
      position: relative;
      .image {
        width: 100%;
        height: 100%;
      }
      .booth {
        top: 230px;
        font-size: 18px;
      }
      .brand {
        top: auto;
        bottom: 115px;
        min-width: auto;
        font-size: 13px;
        font-weight: 400;
        padding-right: 15px;
      }
      .code-icon {

        position: absolute;
        z-index: 9;
        bottom: 28px;
        right: 15px;
      }
      &:hover .item-mask{
        opacity: 1;
      }
      .item-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 99;
        opacity: 0;
        padding: 100px 0 0;
        transition: all 0.3s;
        box-sizing: border-box;
        background: rgba($color: #000, $alpha: 0.4);
        .item-btn {
          width: 110px;
          height: 40px;
          color: #fff;
          font-size: 14px;
          line-height: 40px;
          text-align: center;
          background: #1677ff;
          border-radius: 5px;
          margin: 30px auto 0;
          display: block;
          &:hover{
            opacity: 0.95;
          }
        }
        .del-btn{
          background: #FF4D4F;
        }
      }
    }
  }
}
.el-upload-list__item {
  transition: none !important;
  -webkit-transition: nonne !important;
}
.el-upload-list__item-name {
  transition: none !important;
  -webkit-transition: nonne !important;
}
.el-upload-list--text {
  display: none !important;
}
</style>